import {
  TRIP_TOOLS_TABS_ID,
  DETAIL_NAV_TOP_ID,
  DETAIL_NAV_HEADER_PAGE_TITLE_ID,
} from '#/shared/constants';

/**
 * Focuses the first focusable element found in the DOM from a predefined
 * priority order. The elements are checked in order, and focus is applied
 * to the first one that exists.
 */

export default function focusFirstAvailableElement(): void {
  if (typeof window === 'undefined') return;

  requestAnimationFrame(() => {
    const focusOrder: string[] = [
      DETAIL_NAV_HEADER_PAGE_TITLE_ID,
      DETAIL_NAV_TOP_ID,
      TRIP_TOOLS_TABS_ID,
    ];

    // Try focusOrder IDs in order, focusing the first one found in the DOM
    const focusElement = focusOrder.find(id => document.getElementById(id));

    if (focusElement) {
      document.getElementById(focusElement)?.focus();
    }
    // if it finds nothing, redo the array
    else {
      document.getElementById(DETAIL_NAV_HEADER_PAGE_TITLE_ID)?.focus();
    }
  });
}
